import React from "react";
import { Row, Col } from "react-bootstrap";
import { MdDone } from "react-icons/md";
import { FaGooglePlay, FaAppStoreIos } from "react-icons/fa";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import MobileDetect from 'mobile-detect'

import { createOng } from "../../../../store/register/ong/actions"
import { createPassager } from "../../../../store/register/passager/actions"
import { createProvider } from "../../../../store/register/provider/actions"

// import UILoadingAnim from '../../../../components/UILoadingAnim/index'

import img_app from '../../src/assets/img/img_app.png'
const img_logo = 'https://cdn.sigmobi.com/lpimg/ic_logo_top_flyer.png'

class SuccessStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileDetect: new MobileDetect(window.navigator.userAgent),
      is_android: false,
      is_ios: false,
      url_escritorio: `${process.env?.REACT_APP_API_URL || 'https://app.sigmobi.com'}/user/signin`
    };
  }

  componentDidMount() {
    if (!this.props?.success) {
      this.props.mainSetState({ current_step: 0 });
    }

    const mobileInfo = [
      this.state.mobileDetect.mobile()?.toLocaleLowerCase(),
      this.state.mobileDetect.os()?.toLocaleLowerCase()
    ]

    this.setState({
      is_ios: [
        mobileInfo.includes('iphone'),
        mobileInfo.includes('ios')
      ].some(v => v),
      is_android: [
        mobileInfo.includes('iphone'),
        mobileInfo.includes('ios')
      ].some(v => v)
    })
  }

  appStores = {
    provider: {
      google_play: 'https://play.google.com/store/apps/details?id=top.gomobi.provider&hl=pt&gl=US&pli=1',
      app_store: 'https://apps.apple.com/br/app/sig-mobi-motorista/id6446038621'
    },
    passager: {
      google_play: 'https://play.google.com/store/apps/details?id=top.gomobi.user&hl=pt',
      app_store: 'https://apps.apple.com/br/app/sig-mobi-passageiro/id6471037040'
    }
  }

  getAppStoreLink(store = 'google_play') {
    const { type } = this.props
    return this.appStores[type ? type : 'passager'][store] || '#'
  }

  render() {
    
    return (
      <Row>
        <Col sm="12">
          <img className="logo" src={img_logo} />
        </Col>
        <Col className="success-component" >
          <div className="background"></div>

          <div className="left">

            <h1><MdDone /></h1>
            <img className="app-image" src={img_app} />

            <h4> Cadastro realizado com Sucesso!</h4>
            
            {
              this.props.type_form &&
              this.props.type_form !== 3 ?
                <>
                  <p className="fw-lighter mt-3">
                    <b className="lead">Obrigado por se cadastrar!</b><br />
                    Siga as dicas a baixo para download do APP Correpondente. <br />
                    Agora você pode baixar nosso aplicativo nas lojas oficiais:
                  </p>

                  <div className="store-links">
                    <a
                      href={this.getAppStoreLink('google_play')}
                      className="btn btn-primary"
                      aria-label="Play Store"
                      target="_blank"
                    >
                      <FaGooglePlay /> Play Store
                    </a>
                    <a
                      href={this.getAppStoreLink('app_store')}
                      className="btn btn-secondary"
                      aria-label="App Store"
                      target="_blank"
                    >
                      <FaAppStoreIos /> App Store
                    </a>
                  </div>
                </>
                :
                <>
                  <p className="fw-lighter mt-3">
                    <b className="lead">Obrigado por se cadastrar!</b><br />
                    ACESSE O ESCRITÓRIO VIRTUAL PARA COMPARTILHAR O SEU LINK DE CADASTRO
                  </p>
                  <div className="store-links">
                    <a
                      href={this.state.url_escritorio}
                      className="btn btn-primary"
                      aria-label="ESCRITÓRIO VIRTUAL"
                      target="_blank"
                    >
                      ESCRITÓRIO VIRTUAL
                    </a>
                  </div>
                </>
            }

          </div>

          <div className="right">
            <img className="app-image" src={img_app} />
          </div>
        </Col>
      </Row>
    )
  }
}

SuccessStep.PropTypes = {
  success: PropTypes.bool,
  type: PropTypes.string,
  type_form: PropTypes.any
}

const mapStateToProps = (state) => {
  const success = [
    state.Ong?.success || false,
    state.Provider?.success || false,
    state.Passager?.success || false
  ].some(v => v)

  const type = [
    state.Ong?.success ? state.Ong.formType : null,
    state.Provider?.success ? state.Ong.formType : null,
    state.Passager?.success ? state.Ong.formType : null,
  ].filter(v => v)[0] || 'passager'

  if (success) {
    localStorage.removeItem('foto-veiculo')
    localStorage.removeItem('picture')
    localStorage.removeItem('form')
    localStorage.removeItem('cnh')
    localStorage.removeItem('crlv')
  }

  return {
    success: success,
    type: type
  }
};

export default withTranslation()(withRouter(connect(mapStateToProps, {
  createOng,
  createPassager,
  createProvider
})(SuccessStep)));